export const DATA_RETENTION_LIMITS = {
  attempts: 5000,
  learningEvents: 5000,
  wrongQuestions: 1000,
  assessmentRecords: 500,
} as const

export interface DataArchiveStats {
  attempts: number
  learningEvents: number
  wrongQuestions: number
  assessmentRecords: number
  lastArchivedAt: string | null
}

export function createEmptyArchiveStats(): DataArchiveStats {
  return {
    attempts: 0,
    learningEvents: 0,
    wrongQuestions: 0,
    assessmentRecords: 0,
    lastArchivedAt: null,
  }
}

export function appendWithRetention<T>(
  current: readonly T[],
  item: T,
  limit: number,
): { items: T[]; archivedCount: number } {
  const items = [...current, item]
  const archivedCount = Math.max(0, items.length - limit)
  return {
    items: archivedCount > 0 ? items.slice(archivedCount) : items,
    archivedCount,
  }
}

export function addArchivedCount(
  stats: DataArchiveStats,
  field: keyof Omit<DataArchiveStats, 'lastArchivedAt'>,
  count: number,
): DataArchiveStats {
  if (count <= 0) return stats
  return {
    ...stats,
    [field]: stats[field] + count,
    lastArchivedAt: new Date().toISOString(),
  }
}
